(ns app.front.view.group.admin.letter.violation-snippet-editor
  (:require [app.domain.letter.model :as letter-model]
            [app.front.ui.text-editor :as text-editor]
            [app.front.view.group.admin.templates.document-editor :as document-editor])
  (:require-macros [core.util.util :as util]))

(def violation-editor-data
  [{:title    :letter/deficiency-snippet
    :fragment :letter-fragment/violation-snippet}
   {:title    :letter/non-compliant-deficiency-snippet
    :fragment :letter-fragment/non-compliant-violation-snippet}
   {:title    :letter/compliant-deficiency-snippet
    :fragment :letter-fragment/compliant-violation-snippet}])

(defn violation-snippet-editor [{:keys [title
                                        fragment]}
                                {:keys [get-external-edit-state-key
                                        tr
                                        images
                                        group-id
                                        document-id
                                        inherited?
                                        group-features
                                        feature-flags]}]
  [document-editor/editor
   (-> (util/mmap {:title              [:h4 (tr [title])]
                   :read-only?         inherited?
                   :placeholders       (cond->> (letter-model/violation-snippet-variables feature-flags)
                                         (not (contains? group-features :group.feature/comply-by-date))
                                         (remove #(= % "comply-by-date")))
                   :small?             true
                   :html-fragment-type fragment}
                  tr images group-id document-id)
       (text-editor/with-external-edit-state (get-external-edit-state-key fragment)))])

(defn violation-snippets-editor [{:keys [visible-fragment-types] :as ctx}]
  (->> violation-editor-data
       (keep (fn [editor-data]
               (when (contains? visible-fragment-types (:fragment editor-data))
                 [violation-snippet-editor editor-data ctx])))
       (into [:<>])))
